if (!window.fetch) window.fetch = require('.').default || require('.');



//////////////////
// WEBPACK FOOTER
// ./node_modules/unfetch/polyfill.js
// module id = 364
// module chunks = 0